<template>
<div class="chapter">
<div class="inner_page">
<p class="image5c"><a id="page_6"><img alt="Image" height="277" src="images/3.jpg" width="300"/></a></p><a id="page_6">
<p class="noindent">Get a planner. Write things down. Not just what you <span class="txit">have</span> to do, like papers, projects, etc., but things you <span class="txit">want</span> to do. Want to spend time with a friend? Write it down. Want to volunteer with Habitat for Humanity? Write it down.</p>
<p class="indent">Most opportunities in life won’t come your way unless you plan for them to happen. I’m not talking about becoming a schedule slave; but looking at our weeks or months in the context of all that we have to do, all the places we have to be, and also our deepest desires that bring meaning to our lives. Being organized in this way helps maintain a balance between our immediate needs and long-term goals.</p>
</a><p class="indent"><a id="page_6">Let’s say your priorities are (1) God, (2) education, (3) work, (4) friends, (5) serving others, (6) free time, and (7) household chores. Open your planner or calendar. Look at the next few weeks and </a><a id="page_7">write down when you plan to do the things that correspond to those priorities. You can use this example as a guide.</a></p><a id="page_7">
<p class="image"><img alt="Image" height="269" src="images/4.jpg" width="420"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch02.vue?28e4d33e